module.exports = __webpack_public_path__ + "img/get-started.20fc64ae.png";